<template>
  <router-link :exact="exact" :to="{ name: route }" class="tabbed-nav-item">
    <slot />
  </router-link>
</template>

<script>
export default {
  name: 'tabbed-nav-item',
  props: {
    exact: {
      type: Boolean,
      default: false,
    },
    route: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.tabbed-nav-item {
  height: 48px;
  display: flex;
  flex: 1;
  align-items: center;
  text-transform: uppercase;
  justify-content: center;
  border-radius: 8px 8px 0 0;
  transition: all 128ms ease-in-out;

  &:hover {
    color: color('primary', 'dark');
    background: rgba(black, 0.02);
  }

  &.router-link-active {
    font-weight: 500;
    color: color('primary');
  }
}
</style>
